<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="dialogKey"
  [headerTheme]="'simple'"
  [title]="'Editar verbete'"
  [appendTo]="'body'"
  [maxWidth]="'760px'"
  (onClose)="onDialogClosed()">
  @if (entry(); as current) {
    <div class="edit" data-testid="dictionary-entry-edit-dialog">
      <p class="edit__context">
        <strong>{{ current.label }}</strong>
        <span>{{ statementLabel() }}{{ current.path ? ' · ' + current.path : '' }}</span>
      </p>
      <p class="edit__hint">
        Salvar cria uma versão nova do dicionário, usada pelo agente de De/Para a partir da próxima
        execução. A versão atual continua no histórico, e dá para voltar a ela.
      </p>

      <app-input
        [type]="'textarea'"
        [label]="'Definição'"
        [textCenter]="false"
        [ngModel]="definition()"
        (ngModelChange)="definition.set($event ?? '')"
        data-testid="dictionary-entry-edit-definition" />

      <div class="edit__field">
        <app-input
          [type]="'textarea'"
          [label]="'Entra (um exemplo por linha)'"
          [textCenter]="false"
          [ngModel]="includesText()"
          (ngModelChange)="includesText.set($event ?? '')"
          data-testid="dictionary-entry-edit-includes" />
      </div>

      <fieldset class="edit__excludes">
        <legend>NÃO entra (item e para onde vai)</legend>
        @for (exclusion of excludes(); track $index; let index = $index) {
          <div class="edit__exclude-row" data-testid="dictionary-entry-edit-exclude-row">
            <app-input
              class="edit__exclude-item"
              [placeholder]="'O que não entra'"
              [textCenter]="false"
              [ngModel]="exclusion.item"
              (ngModelChange)="updateExclusion(index, 'item', $event)" />
            <i class="pi pi-arrow-right edit__exclude-arrow" aria-hidden="true"></i>
            <app-input
              class="edit__exclude-goes-to"
              [placeholder]="'Conta de destino'"
              [textCenter]="false"
              [ngModel]="exclusion.goesTo"
              (ngModelChange)="updateExclusion(index, 'goesTo', $event)" />
            <button
              type="button"
              class="edit__remove"
              aria-label="Remover item"
              (click)="removeExclusion(index)">
              <i class="pi pi-trash" aria-hidden="true"></i>
            </button>
          </div>
        }
        <button type="button" class="edit__add" (click)="addExclusion()">
          <i class="pi pi-plus" aria-hidden="true"></i>
          Acrescentar item
        </button>
      </fieldset>

      <app-input
        [type]="'textarea'"
        [label]="'Erros comuns (um por linha)'"
        [textCenter]="false"
        [ngModel]="pitfallsText()"
        (ngModelChange)="pitfallsText.set($event ?? '')"
        data-testid="dictionary-entry-edit-pitfalls" />

      <app-input
        [type]="'textarea'"
        [label]="'Decisões da casa (uma por linha)'"
        [textCenter]="false"
        [ngModel]="decisionsText()"
        (ngModelChange)="decisionsText.set($event ?? '')"
        data-testid="dictionary-entry-edit-decisions" />

      <app-input
        [type]="'textarea'"
        [label]="'Base normativa'"
        [textCenter]="false"
        [ngModel]="normativeBasis()"
        (ngModelChange)="normativeBasis.set($event ?? '')"
        data-testid="dictionary-entry-edit-normative-basis" />

      <app-input
        [type]="'textarea'"
        [label]="'Motivo da mudança'"
        [placeholder]="'O que mudou e por quê (fica no histórico de versões)'"
        [required]="true"
        [textCenter]="false"
        [maxLength]="reasonMaxLength"
        [ngModel]="reason()"
        (ngModelChange)="reason.set($event ?? '')"
        data-testid="dictionary-entry-edit-reason" />
    </div>
  }

  <ng-template #footer>
    <div class="edit__footer">
      <app-button
        [label]="'Cancelar'"
        [theme]="'white'"
        [type]="'button'"
        (sendButtonClick)="close()" />
      <app-button
        [label]="'Salvar nova versão'"
        [theme]="'default'"
        [type]="'button'"
        [disabled]="!isFormValid()"
        data-testid="dictionary-entry-edit-confirm"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
